<template>
  <v-container fluid>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card color="#F3F5F8">
        <v-card-title>
          <h4 class="titleText--text">Avilable Licence</h4>
          <v-spacer />
          <v-btn icon @click="closeForm()">
            <v-icon color="titleText">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left titleText--text font-weight-bold">Application</th>
                    <th class="text-right titleText--text font-weight-bold">Purchased</th>
                    <th class="text-right titleText--text font-weight-bold">Used</th>
                    <th class="text-right titleText--text font-weight-bold">Avilable License</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(items) in listapps" :key="items.id">
                    <td class="text-left titleText--text font-weight-bold">{{ items.Application }}</td>
                    <td class="text-right titleText--text">{{ items.Purchased_No_of_License }}</td>
                    <td class="text-right titleText--text">{{ items.Used_No_of_License }}</td>
                    <td class="text-right titleText--text">{{ items.Available_No_of_License }}</td>
                   
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import apifactory from "../api";
export default {
  components: {},
  data() {
    return {
      dialog: false,
    listapps:[]
    };
  },
  mounted() {},
  computed: {},
  methods: {
    
    
    OnloadCall() {
    // alert('OnloadCall');
      this.dialog = true;
      this.loadallapps();
    
    },
    closeForm() {
      this.dialog = false;
    
    },
    loadallapps() {
      apifactory
        .apicall_getapplicence()
        .then((res) => {
          // alert(JSON.stringify(res));
          if (res.status != 200) {
            this.listapps = null;
            // alert(this.processdataitems.length);
          } else {
            this.listapps = res.data.available_license;
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
  },
};
</script>

<style scoped>
.inactive-bg {
  color: red;
}

.inactive-bg-green {
  color: green;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row) {
  border-color: white !important;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  border-color: white !important;
  background-color: white !important;
}
</style>
